import React from 'react';
import { Drawer } from 'antd';

function SidePanel({ open, onCancel, title, footer, width = 520, children, onOk, ...rest }) {
    return (
        <Drawer
            open={open}
            onClose={onCancel}
            title={title}
            width={width}
            footer={
                footer ? (
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>{footer}</div>
                ) : undefined
            }
            {...rest}
        >
            {children}
        </Drawer>
    );
}

export default SidePanel;
